export default __webpack_public_path__ + "images/90-konto-logo_7e3741ab5b458bb35679b8c6065ba76e.png";